import { Editor as CoreEditor } from '@tiptap/core';
export class Editor extends CoreEditor {
    constructor() {
        super(...arguments);
        this.contentElement = null;
    }
}
